import { Box, Card, Text } from '@ksyos/design-system';

export function InvoicingNotInsured() {
    return (
        <>
            <Card>
                <Card.Body>Volgens onze gegevens ben jij niet verzekerd binnen Nederland.</Card.Body>
            </Card>

            <Card>
                <Card.Body>
                    <Box
                        display="flex"
                        flexDirection="column"
                        gap={6}
                        maxWidth={620}
                    >
                        <Box
                            alignItems="center"
                            display="flex"
                            flexDirection="row"
                            gap={6}
                        >
                            <img
                                alt="factuur"
                                src="/assets/images/somnology/insurance/Factuur_MK.svg"
                                style={{ width: '67px' }}
                            />
                            <Text>
                                Ksyos stuurt de rekening(en) direct naar jou. Hierin staan de kosten voor de zorg die je
                                hebt ontvangen.
                            </Text>
                        </Box>

                        <Box
                            alignItems="center"
                            display="flex"
                            flexDirection="row"
                            gap={6}
                        >
                            <img
                                alt="patient-betaalt"
                                src="/assets/images/somnology/insurance/Vergoeding_MK.svg"
                                style={{ width: '67px' }}
                            />
                            <Text>Jij betaalt het hele bedrag aan Ksyos.</Text>
                        </Box>
                        <Box
                            alignItems="center"
                            display="flex"
                            flexDirection="row"
                            gap={6}
                        >
                            <img
                                alt="email-post"
                                src="/assets/images/somnology/insurance/Declareren_MK.svg"
                                style={{ width: '67px' }}
                            />
                            <Text>Je kunt de rekening eventueel zelf indienen bij een buitenlandse verzekeraar.</Text>
                        </Box>
                    </Box>
                </Card.Body>
            </Card>
        </>
    );
}
